import GenericLoader from './GenericLoader';

export default GenericLoader;
